export default __webpack_public_path__ + "static/media/disamr-logo.aac31ae0.svg";